import {CustomerDetailsService} from "./service/CustomerDetailService";
import {CustomerService} from "./service/CustomerService";
import {
    CUSTOMER_DETAILS_SERVICE_NAME,
    CustomerServiceName,
    ToastNotificationServiceName
} from "../utils/names/serviceNames";
import {CustomerServiceModuleConfiguration} from "./CustomerServiceModuleConfiguration";

CustomerServiceModuleConfiguration
    .createNewModule()
    .service(CUSTOMER_DETAILS_SERVICE_NAME, ['$log', '$http', 'LoaderStatusValue', ToastNotificationServiceName, CustomerDetailsService])
    .service(CustomerServiceName, ['$http', CustomerService]);